module.exports = __webpack_public_path__ + "img/key_features--foot_controls.0cd5b747.png";